import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useIntersectionObserver } from "../hooks/index.js";
import { Box } from "../Box/index.js";
import { CircularProgress } from "../CircularProgress/index.js";
import { FilePreviewWrapper } from "./FilePreviewWrapper.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const FilePreview = (props)=>{
    const $ = c(13);
    const [isIntersected, setIsIntersected] = useState(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            threshold: 0,
            root: null,
            rootMargin: "100px"
        };
        $[0] = t0;
    } else t0 = $[0];
    const [ref, entry] = useIntersectionObserver(t0);
    let t1;
    if ($[1] !== (null == entry ? void 0 : entry.isIntersecting)) {
        t1 = ()=>{
            if (null == entry ? void 0 : entry.isIntersecting) setIsIntersected(true);
        };
        $[1] = null == entry ? void 0 : entry.isIntersecting;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = null == entry ? void 0 : entry.isIntersecting;
    let t3;
    if ($[3] !== t2) {
        t3 = [
            t2
        ];
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    useEffect(t1, t3);
    let t4;
    if ($[5] !== ref) {
        t4 = /*#__PURE__*/ jsx(Box, {
            ref: ref,
            component: "span",
            position: "absolute"
        });
        $[5] = ref;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isIntersected || $[8] !== props) {
        t5 = isIntersected ? /*#__PURE__*/ jsx(FilePreviewWrapper, _object_spread({}, props)) : !props.hideLoader && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            p: "32",
            children: /*#__PURE__*/ jsx(CircularProgress, {
                size: 50
            })
        });
        $[7] = isIntersected;
        $[8] = props;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t4,
                t5
            ]
        });
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
export { FilePreview };
